var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.69182 0.5 0 3.19191 0 6.5C0 9.80809 2.69191 12.5 6 12.5C9.30809 12.5 12 9.80809 12 6.5C12 3.19191 9.30809 0.5 6 0.5ZM6 1.44742C8.79609 1.44742 11.0526 3.70394 11.0526 6.50006C11.0526 9.29615 8.79612 11.5527 6 11.5527C3.20388 11.5527 0.947369 9.29618 0.947369 6.50006C0.947369 3.70397 3.20388 1.44742 6 1.44742ZM6 2.2369C5.73842 2.2369 5.52629 2.44902 5.52629 2.71061V6.50008C5.52629 6.67531 5.62178 6.82763 5.76308 6.90957L8.77295 8.64635C8.99951 8.7772 9.28851 8.70021 9.41936 8.47366C9.55021 8.2471 9.47322 7.9581 9.24667 7.82725L6.4737 6.22859V2.71064C6.4737 2.44906 6.2617 2.2369 6 2.2369Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.9323feb270cf32b5e8947c8f068ef45e.svg";
export { ForwardRef as ReactComponent };